import styled, { css } from "styled-components";
import type { Theme } from "../theme.ts";

type Gap = keyof Theme["space"];
type Direction = "row" | "column";
type Justify = "start" | "center" | "end" | "between" | "around";
type Align = "start" | "center" | "end" | "stretch";

const justifyMap: Record<Justify, string> = {
  start: "flex-start",
  center: "center",
  end: "flex-end",
  between: "space-between",
  around: "space-around",
};

const alignMap: Record<Align, string> = {
  start: "flex-start",
  center: "center",
  end: "flex-end",
  stretch: "stretch",
};

export const Stack = styled.div<{
  $direction?: Direction;
  $gap?: Gap;
  $justify?: Justify;
  $align?: Align;
  $wrap?: boolean;
}>`
  display: flex;
  flex-direction: ${({ $direction = "column" }) => $direction};
  gap: ${({ theme, $gap = "md" }) => theme.space[$gap]};
  ${({ $justify }) =>
    $justify &&
    css`
      justify-content: ${justifyMap[$justify]};
    `}
  ${({ $align }) =>
    $align &&
    css`
      align-items: ${alignMap[$align]};
    `}
  ${({ $wrap }) =>
    $wrap &&
    css`
      flex-wrap: wrap;
    `}
`;
